import {
  ProductCatalogColorGroup,
  ProductCatalogProductColorOption,
} from '../../__generated__/graphql/catalog/graphql'

type RequiredColorGroupFields = Pick<ProductCatalogColorGroup, 'displayValue' | 'id'>
type RequiredColorOptionFields = {
  outOfStock: ProductCatalogProductColorOption['outOfStock']
  color: {
    id: ProductCatalogProductColorOption['color']['id']
    displayValue: ProductCatalogProductColorOption['color']['displayValue']
    hexCodes: ProductCatalogProductColorOption['color']['hexCodes']
    group: ProductCatalogProductColorOption['color']['group']
    swatchImage?: {
      url: NonNullable<ProductCatalogProductColorOption['color']['swatchImage']>['url']
    } | null
  }
}

type GroupedOptions = {
  group: RequiredColorGroupFields
  colorOptions: Array<RequiredColorOptionFields>
}

type MapOfGroupedOptions = Record<string, GroupedOptions>

export const groupColorOptionsByColorGroup = (
  colorOptions: RequiredColorOptionFields[]
): GroupedOptions[] => {
  const colorGroups: MapOfGroupedOptions = {}
  colorOptions.forEach(colorOption => {
    const colorGroup = colorOption.color.group?.id
      ? colorGroups[colorOption.color.group.id]
      : undefined

    if (colorGroup) {
      colorGroup.colorOptions.push(colorOption)
    } else if (colorOption.color.group?.id) {
      colorGroups[colorOption.color.group.id] = {
        group: colorOption.color.group,
        colorOptions: [colorOption],
      }
    }
  })
  return Object.values(colorGroups)
}
